import Link from "components/templatesComponents/Link";
import PropTypes from "prop-types";
import React from "react";

const SeeMoreLink = (props) => {
  const { page = null, children = null, ...others } = props;

  return (
    <Link
      page={page}
      iconDSFR="arrow-right-s-line"
      sx={{ color: "primary.40", fontWeight: 600, width: "fit-content", backgroundImage: "none" }}
      {...others}
    >
      {children}
    </Link>
  );
};

SeeMoreLink.propTypes = {
  page: PropTypes.shape(),
  children: PropTypes.node,
};

export default SeeMoreLink;
